/**
 * Phantasm dispatch contact — canonical, single source of truth.
 *
 * Extracted in Phase 16e after a phone-number mix-up shipped in ManageBooking.
 * Any component that needs to render a "call dispatch" CTA must import from
 * here. Do NOT hardcode phone strings elsewhere.
 */
export const DISPATCH_PHONE_E164 = "+13475230763";
export const DISPATCH_PHONE_DISPLAY = "+1-347-523-0763";
export const DISPATCH_TEL_HREF = `tel:${DISPATCH_PHONE_E164}`;
